import { useState, useEffect, useMemo } from "react";
import { ListaClientesPorEjecutivo, Header } from "../../components";
import { useAuthContext } from "../../context/auth";
import { getClientesPublicitarios, getCategorias } from "../../utils";
import styles from "./ClientesCartera.module.scss";

export const ClientesCartera = () => {
  const { pais } = useAuthContext();
  const [clientes, setClientes] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [filtroCliente, setFiltroCliente] = useState("");
  const [filtroCategoria, setFiltroCategoria] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const [clientesData, categoriasData] = await Promise.all([getClientesPublicitarios({ pais }), getCategorias()]);
      setClientes(clientesData || []);
      setCategorias(categoriasData || []);
    };
    fetchData();
  }, [pais]);

  const clientesSorted = useMemo(() => [...clientes].sort((a, b) => a.nombre.localeCompare(b.nombre)), [clientes]);

  return (
    <div className={styles.page}>
      <Header leftContent={<h1 className={styles.titulo}>Cartera Clientes por Ejecutivo</h1>}>
        <select
          className={`${styles.filterSelect} ${filtroCliente ? styles.activeFilter : ""}`}
          value={filtroCliente}
          onChange={(e) => setFiltroCliente(e.target.value)}
        >
          <option value="">Todos los Clientes</option>
          {clientesSorted.map((c) => (
            <option key={c.id} value={c.id}>
              {c.nombre}
            </option>
          ))}
        </select>

        <select
          className={`${styles.filterSelect} ${filtroCategoria ? styles.activeFilter : ""}`}
          value={filtroCategoria}
          onChange={(e) => setFiltroCategoria(e.target.value)}
        >
          <option value="">Todas las Categorías</option>
          {categorias.map((c) => (
            <option key={c.id} value={c.id}>
              {c.nombre}
            </option>
          ))}
        </select>
      </Header>

      <div className={styles.content}>
        <ListaClientesPorEjecutivo
          clientes={clientes}
          categorias={categorias}
          filtroCliente={filtroCliente}
          filtroCategoria={filtroCategoria}
        />
      </div>
    </div>
  );
};
